import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { AccaBoostConfig } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RewardTokenType } from '../../../../../lib/tokens-base/token-base.models';
import { IBetslipRootState } from '../../../../base/store/state';
import { RewardTokensActions } from '../../../reward-tokens/actions';
import { RewardTokenContext } from '../../../reward-tokens/reward-tokens.model';
import { selectIsRewardTokensSelectorVisible } from '../../../reward-tokens/selectors';

@Component({
    selector: 'bs-digital-token-summary',
    templateUrl: './token-summary.component.html',
    styleUrls: ['./token-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TokenSummaryComponent implements OnInit {
    @Input() summaryMessage?: string;
    @Input() tokenType?: RewardTokenType;
    @Input() tokenContext: RewardTokenContext;

    @HostBinding('class') readonly hostClass = 'reward-tokens-module';

    readonly RewardTokenType = RewardTokenType;
    isRewardTokenSelectorVisible$: Observable<boolean>;

    constructor(
        private store: Store<IBetslipRootState>,
        public accaBoostConfig: AccaBoostConfig,
    ) {}

    ngOnInit(): void {
        this.isRewardTokenSelectorVisible$ = this.store.select(selectIsRewardTokensSelectorVisible(this.tokenContext));
    }

    displayInfo(): void {
        this.store.dispatch(RewardTokensActions.showOverlayInfo({ tokenContext: this.tokenContext, hideTabs: true }));
    }
}
